module.exports = __webpack_public_path__ + "dashboard/img/file.b77b18722349e3909aa6b280d4b8f5f1.svg";